import { render, staticRenderFns } from "./ConfiguredTextAreaEditor.vue?vue&type=template&id=ca7c0c7c&"
import script from "./ConfiguredTextAreaEditor.vue?vue&type=script&lang=ts&"
export * from "./ConfiguredTextAreaEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports